import { render, staticRenderFns } from "./PopularPhrasesBar.vue?vue&type=template&id=c6e1908a"
import script from "./PopularPhrasesBar.vue?vue&type=script&lang=ts"
export * from "./PopularPhrasesBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports